import React from 'react';
import PropTypes from 'prop-types';
import { attributeText as AttributeText } from 'theme/icon';
import { Input, Tooltip } from 'antd';
import _ from 'lodash';
import cn from 'classnames';
import styles from './styles.scss';
import CustomScroll from '../../../../../CustomTender/control/scroll';

const TextAttribute = props => {
  const { isEditable } = props;
  return (
    <div className={cn(styles.row, styles.text)}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <AttributeText alt="" />
        </div>
        <div className={styles.caption}>
          <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
            <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
          </Tooltip>
        </div>
      </div>
      <div className={styles.body}>
        <CustomScroll universal style={{ width: 275, height: 75 }}>
          {isEditable ? (
            <Input value={props.value} onChange={e => props.onChange(e.target.value)} maxLength={500} />
          ) : (
            <React.Fragment>{props.value && <span className={styles.value}>{props.value}</span>}</React.Fragment>
          )}
        </CustomScroll>
      </div>
    </div>
  );
};

TextAttribute.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  isEditable: PropTypes.oneOf([PropTypes.objectOf(PropTypes.bool), PropTypes.bool]).isRequired,
};

TextAttribute.defaultProps = {
  value: null,
};

export default TextAttribute;
